module.exports = __webpack_public_path__ + "static/media/stat-mode.2587b62c.png";